import React from "react";
import { useState } from "react";

// ==== video imports ====
import videoOne from "../../../assets/First Meetings 1.mp4";

// ==== audio track imports ====
import audio16 from "../../../assets/LevelOneAudio/beginner1/1/Navigate A1 Coursebook Audio 01-06.mp3";
import audio17 from "../../../assets/LevelOneAudio/beginner1/1/Navigate A1 Coursebook Audio 01-07.mp3";

function LessonOne() {
  const [q1, setQ1] = useState("");
  const [q2, setQ2] = useState("");
  const [q3, setQ3] = useState("");
  const [q4, setQ4] = useState("");
  const [q5, setQ5] = useState("");
  const [q6, setQ6] = useState("");
  const [q7, setQ7] = useState("");
  const [q8, setQ8] = useState("");
  const [q9, setQ9] = useState("");
  const [q10, setQ10] = useState("");
  const [q11, setQ11] = useState("");
  const [q12, setQ12] = useState("");

  const check = () => {
    console.log(q1);
    console.log(q2);
    console.log(q3);
    console.log(q4);
    console.log(q5);
    console.log(q6);
    console.log(q7);
    console.log(q8);
    console.log(q9);
    console.log(q10);
    console.log(q11);
    console.log(q12);
  };

  return (
    <>
      <div className="row">
        <h3 className="text-center">On business or on holiday?</h3>
        <video
          className="mx-auto col-xs-12 col-sm-12 col-md-12 col-lg-11 mb-5"
          controls
          // autobuffer
          // preload="auto"
        >
          <source src={videoOne} type="video/mp4" />
          <source src={videoOne} type="video/ogg" />
          <source src={videoOne} type="video/webm" />
          Your browser does not support the video tag.
        </video>

        <div className="mx-auto col-xs-12 col-sm-12 col-md-12 col-lg-11">
          <div className="task-one mb-3">
            <h4>
              <span>1a</span> Listen to Hava and Paul. Complete the questions
              and answers.
            </h4>
            <div>
              <audio controls autobuffer preload>
                <source src={audio16} type="audio/mp3" />
                <source src={audio16} type="audio/ogg" />
                <source src={audio16} type="audio/wav" />
                Your browser does not support the audio element.
              </audio>
            </div>
            <p>
              H - Are you here on
              <input
                className="border"
                type="text"
                onChange={(e) => setQ1(e.target.value)}
                style={{
                  background: q1.trim() === "business" ? "#198754" : "white",
                }}
              />
              .
            </p>
            <p>
              P -
              <input
                className="border"
                type="text"
                onChange={(e) => setQ2(e.target.value)}
                style={{
                  background: q2.trim() === "Yes" ? "#198754" : "white",
                }}
              />
              , I am. And
              <input
                className="border"
                type="text"
                onChange={(e) => setQ3(e.target.value)}
                style={{
                  background: q3.trim() === "you" ? "#198754" : "white",
                }}
              />
              ? Are you here on business.
            </p>
            <p>
              H -
              <input
                className="border"
                type="text"
                onChange={(e) => setQ4(e.target.value)}
                style={{
                  background: q4.trim() === "No" ? "#198754" : "white",
                }}
              />
              , I'm not. I'm on
              <input
                className="border"
                type="text"
                onChange={(e) => setQ5(e.target.value)}
                style={{
                  background: q5.trim() === "holiday" ? "#198754" : "white",
                }}
              />
              .
            </p>
            <h4>
              <span>1b</span> Listen, check, and repeat.
            </h4>
            <audio controls autobuffer preload="auto">
              <source src={audio16} type="audio/mp3" />
              <source src={audio16} type="audio/ogg" />
              <source src={audio16} type="audio/wav" />
              Your browser does not support the audio element.
            </audio>
          </div>
          <div className="task-two mb-3">
            <h4>
              <span>2a</span> Complete the conversation between Sunil (S) and
              Julie (J).
            </h4>
            <p>
              S- Hello, I'
              <input
                className="border"
                type="text"
                onChange={(e) => setQ6(e.target.value)}
                style={{
                  background: q6.trim() === "m" ? "#198754" : "white",
                }}
              />
              Sunil.
            </p>
            <p>
              J- Hi, I'
              <input
                className="border"
                type="text"
                onChange={(e) => setQ7(e.target.value)}
                style={{
                  background: q7.trim() === "m" ? "#198754" : "white",
                }}
              />
              Julie.
            </p>
            <p>S- Nice to meet you Julie.</p>
            <p>
              J- And you.
              <input
                className="border"
                type="text"
                onChange={(e) => setQ8(e.target.value)}
                style={{
                  background: q8.trim() === "Are" ? "#198754" : "white",
                }}
              />
              you here on holiday?
            </p>
            <p>
              J- No, I'
              <input
                className="border"
                type="text"
                onChange={(e) => setQ9(e.target.value)}
                style={{
                  background: q9.trim() === "m not" ? "#198754" : "white",
                }}
              />
              . I'
              <input
                className="border"
                type="text"
                onChange={(e) => setQ10(e.target.value)}
                style={{
                  background: q10.trim() === "m" ? "#198754" : "white",
                }}
              />
              here to study. And you?
              <input
                className="border"
                type="text"
                onChange={(e) => setQ11(e.target.value)}
                style={{
                  background: q11.trim() === "Are" ? "#198754" : "white",
                }}
              />
              you on holiday?
            </p>
            <p>
              J- Yes, I
              <input
                className="border"
                type="text"
                onChange={(e) => setQ12(e.target.value)}
                style={{
                  background: q12.trim() === "am" ? "green" : "white",
                }}
              />
              .
            </p>
            <audio controls autobuffer preload="auto">
              <source src={audio17} type="audio/mp3" />
              <source src={audio17} type="audio/ogg" />
              <source src={audio17} type="audio/wav" />
              Your browser does not support the audio element.
            </audio>
          </div>
        </div>
      </div>
    </>
  );
}

export default LessonOne;
